module.exports = __webpack_public_path__ + "static/media/HB_gardenerspie_forweb2_edited.9aadd1c0.jpg";